import { captureException } from '@sentry/react';
import type { ErrorReportContext } from './reportError.types';

const reportError = (error: unknown, context: ErrorReportContext): void => {
	console.error(error, context);

	captureException(error, {
		contexts: { react: { componentStack: context.componentStack } },
		extra: { message: context.message }
	});
};

export { reportError };
